import Expandable from "./Expandable";
import { loadStorageData, saveStorageData } from "../../Services/LocalStorage";
const VALUE_PATH = "ui.drawer.collapsedMenuGroups";
export default class MenuPanel {
    constructor(_root) {
        this.root = _root;
        this.button = Array.from(this.root.querySelectorAll(".neos-menu-button"));
        this.panel = Array.from(this.root.querySelectorAll(".neos-menu-panel"));
        this.menuSectionStates = this.loadMenuSectionStates();
        this.setupEventListeners();
        if (this.panel) {
            this.initializeMenuSections();
        }
    }
    initializeMenuSections() {
        this.panel.forEach((_panel) => {
            const menuSectionElements = _panel.querySelectorAll(".neos-menu-section");
            const sections = this.menuSectionStates;
            menuSectionElements.forEach((menuSectionElement) => {
                const sectionName = menuSectionElement.getAttribute("data-key");
                const sectionState = !sections.includes(sectionName);
                new Expandable(menuSectionElement, ".neos-menu-panel-toggle", this.onMenuSectionStateChange.bind(this), sectionState);
            });
        });
    }
    setupEventListeners() {
        this.button.forEach((_toggleButton) => {
            _toggleButton.addEventListener("click", this.toggle.bind(this));
        });
    }
    loadMenuSectionStates() {
        const storageData = loadStorageData(VALUE_PATH);
        return Array.isArray(storageData) ? storageData : [];
    }
    saveMenuSectionStates() {
        if (Array.isArray(this.menuSectionStates)) {
            saveStorageData(VALUE_PATH, this.menuSectionStates);
        }
    }
    onMenuSectionStateChange(sectionName, newValue) {
        if (this.menuSectionStates.includes(sectionName) && newValue === true) {
            this.menuSectionStates = this.menuSectionStates.filter((item) => item !== sectionName);
        }
        if (!this.menuSectionStates.includes(sectionName) && newValue === false) {
            this.menuSectionStates.push(sectionName);
        }
        this.saveMenuSectionStates();
    }
    toggle(_event) {
        this.button.forEach((_toggleButton) => {
            _toggleButton.classList.toggle("neos-pressed");
        });
        document.body.classList.toggle("neos-menu-panel-open");
    }
}
